import React from 'react';

import './app-header.css';

const AppHeader = () => {
	return <h1>todos</h1>;
};

export default AppHeader;
